import { render } from "./welcome-a.vue?vue&type=template&id=386d936c"
import script from "./welcome-a.vue?vue&type=script&lang=js"
export * from "./welcome-a.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__